module.exports = __webpack_public_path__ + "static/media/idlepage.7f279d55.svg";